import { connect } from 'react-redux';
import ResultsComponent from '../../components/results';

/** @internal */
export function mapStateToProps(state) {
	return {
		category: state.bow.category,
		awardType: state.bow.awardType,
		location: state.bow.location,
		totalBOWVendors: state.bow.totalBOWVendors,
		vendors: state.bow.vendors,
		isFetching: state.bow.isFetching,
		searchCompleted: state.bow.searchCompleted,
	};
}

export default connect(mapStateToProps)(ResultsComponent);
